export const Translations_RO = {
	footer: {
		join: "Alăturăte acum acestei discuții. Nu este necesară nicio aplicație sau autentificare.",
		climate: "O discuție pozitivă despre climat.",
		tree: "Copacul a fost plantat.",
		start: "Începeți discuții video, gratuit.",
	},
};
